import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterflyer'
})
export class FilterFlyerPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(it => {
    
      return it.flyer_name.toLowerCase().includes(searchText.toLowerCase());
     
    });
  }

}
